import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, unref as _unref, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4d5acfc8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "chi-tiet-xuat-theo-dt-thead" }
const _hoisted_2 = { class: "chi-tiet-xuat-theo-dt-header-row" }
const _hoisted_3 = ["width"]
const _hoisted_4 = ["width"]
const _hoisted_5 = ["width"]
const _hoisted_6 = ["width"]
const _hoisted_7 = ["width"]
const _hoisted_8 = ["width"]
const _hoisted_9 = ["width"]
const _hoisted_10 = ["width"]
const _hoisted_11 = { class: "chi-tiet-xuat-theo-dt-header-row" }
const _hoisted_12 = ["width"]
const _hoisted_13 = ["width"]
const _hoisted_14 = ["width"]
const _hoisted_15 = ["width"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", { class: "chi-tiet-xuat-theo-dt-header-row" }, [
  /*#__PURE__*/_createElementVNode("th", { class: "text-center fst-italic chi-tiet-xuat-theo-dt-th-meta" }, "A"),
  /*#__PURE__*/_createElementVNode("th", { class: "text-center fst-italic chi-tiet-xuat-theo-dt-th-so" }, "B"),
  /*#__PURE__*/_createElementVNode("th", { class: "text-center fst-italic" }, "C"),
  /*#__PURE__*/_createElementVNode("th", { class: "text-center fst-italic chi-tiet-xuat-theo-dt-th-meta" }, "D"),
  /*#__PURE__*/_createElementVNode("th", { class: "text-center fst-italic chi-tiet-xuat-theo-dt-th-meta" }, "E"),
  /*#__PURE__*/_createElementVNode("th", { class: "text-center fst-italic chi-tiet-xuat-theo-dt-th-meta" }, "F"),
  /*#__PURE__*/_createElementVNode("th", { class: "text-center fst-italic chi-tiet-xuat-theo-dt-th-meta" }, "G"),
  /*#__PURE__*/_createElementVNode("th", { class: "text-center fst-italic chi-tiet-xuat-theo-dt-th-meta" }, "1"),
  /*#__PURE__*/_createElementVNode("th", { class: "text-center fst-italic" }, "2"),
  /*#__PURE__*/_createElementVNode("th", { class: "text-center fst-italic" }, "3 = 1 * 2"),
  /*#__PURE__*/_createElementVNode("th", { class: "text-center fst-italic" }, "4"),
  /*#__PURE__*/_createElementVNode("th", { class: "text-center fst-italic" }, "5 = 1 * 4"),
  /*#__PURE__*/_createElementVNode("th", { class: "text-center fst-italic" }, "6 = 4 - 2"),
  /*#__PURE__*/_createElementVNode("th", { class: "text-center fst-italic" }, "7 = 1 * 6")
], -1))
const _hoisted_17 = { class: "chi-tiet-xuat-theo-dt-tbody" }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  colspan: "14",
  class: "text-center fst-italic"
}, "Không có dữ liệu", -1))
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = { class: "text-center break-word" }
const _hoisted_22 = { class: "break-word chi-tiet-xuat-theo-dt-td-so" }
const _hoisted_23 = { class: "break-word" }
const _hoisted_24 = { class: "break-word" }
const _hoisted_25 = { class: "break-word" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "break-word" }, null, -1))
const _hoisted_27 = { class: "break-word" }
const _hoisted_28 = { class: "text-end break-word" }
const _hoisted_29 = { class: "text-end break-word" }
const _hoisted_30 = { class: "text-end fw-bolder break-word" }
const _hoisted_31 = { class: "text-end break-word" }
const _hoisted_32 = { class: "text-end fw-bolder break-word" }
const _hoisted_33 = { class: "text-end break-word" }
const _hoisted_34 = { class: "text-end fw-bolder break-word" }
const _hoisted_35 = { class: "bao-cao-table-total-row" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  class: "fw-bolder text-center",
  colspan: "7"
}, "Cộng", -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "text-end" }, null, -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "text-end" }, "-", -1))
const _hoisted_39 = { class: "text-end fw-bolder" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "text-end" }, "-", -1))
const _hoisted_41 = { class: "text-end fw-bolder" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "text-end" }, "-", -1))
const _hoisted_43 = { class: "text-end fw-bolder" }

import { computed, PropType } from "vue";
import { IChiTietXuatTheoDoiTuongResponseBase } from "@/core/interfaces/ApiResponses";
import {
  calcLineAmount,
  formatAmount,
  formatQuantity,
  formatUnitPrice,
} from "@/core/helpers/number-format";
import { useDateTime } from "@/core/hooks/use-date-time-hook";
import {
  REPORT_COLUMN_WIDTHS_GROUP,
  REPORT_COLUMN_WIDTHS,
} from "@/components/shared/vat-tu-table/vat-tu-table-column-widths";


export default /*#__PURE__*/_defineComponent({
  __name: 'ChiTietXuatTheoDoiTuongTable',
  props: {
  isPrintModal: {
    type: Boolean as PropType<boolean>,
    required: true,
  },
  items: {
    type: Array as PropType<IChiTietXuatTheoDoiTuongResponseBase[]>,
    required: true,
  },
  stripe: {
    type: Boolean,
    required: true,
  },
},
  setup(__props) {

const colW = {
  stt: REPORT_COLUMN_WIDTHS.stt,
  soBienBanGiaiThe: REPORT_COLUMN_WIDTHS.soBienBanGiaiThe,
  ngay: REPORT_COLUMN_WIDTHS.ngay,
  ma: REPORT_COLUMN_WIDTHS.ma,
  ten: REPORT_COLUMN_WIDTHS.ten,
  dacTinh: REPORT_COLUMN_WIDTHS.dacTinh,
  dvt: REPORT_COLUMN_WIDTHS.dvt,
  donGia: REPORT_COLUMN_WIDTHS.donGia,
  soLuong: REPORT_COLUMN_WIDTHS.soLuong,
  thanhTien: REPORT_COLUMN_WIDTHS.thanhTien,
  dinhMucBbgt: REPORT_COLUMN_WIDTHS.dinhMucBbgt,
  quantityGroup: REPORT_COLUMN_WIDTHS_GROUP.quantityThanhTienGroup,
};

const { formatDisplayingDate } = useDateTime();

const columnArr = ["Theo định mức", "Thực hiện", "Chênh lệch"];

const props = __props;

const totalThanhTien = computed(() => {
  const result = {
    theo_dinh_muc: 0,
    thuc_hien: 0,
    chenh_lech: 0,
  };

  props.items?.forEach(
    ({
      thanh_tien_dinh_muc_co_dinh,
      thanh_tien_chenh_lech,
      don_gia_thuc_hien,
      so_luong_thuc_hien,
    }) => {
      result.theo_dinh_muc += +thanh_tien_dinh_muc_co_dinh;

      result.thuc_hien += +don_gia_thuc_hien * +so_luong_thuc_hien;

      result.chenh_lech += +thanh_tien_chenh_lech;
    }
  );

  return {
    theo_dinh_muc: formatAmount(Math.round(result.theo_dinh_muc)),
    thuc_hien: formatAmount(Math.round(result.thuc_hien)),
    chenh_lech: formatAmount(Math.round(result.chenh_lech)),
  };
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("table", {
    style: { width: '100%', fontSize: '0.8rem' },
    class: _normalizeClass({
      'table-striped': __props.stripe,
      'bao-cao-table--print': __props.isPrintModal,
    })
  }, [
    _createElementVNode("colgroup", null, [
      _createElementVNode("col", {
        style: _normalizeStyle({ width: `${colW.stt}px` })
      }, null, 4),
      _createElementVNode("col", {
        style: _normalizeStyle({ width: `${colW.soBienBanGiaiThe}px` })
      }, null, 4),
      _createElementVNode("col", {
        style: _normalizeStyle({ width: `${colW.ngay}px` })
      }, null, 4),
      _createElementVNode("col", {
        style: _normalizeStyle({ width: `${colW.ma}px` })
      }, null, 4),
      _createElementVNode("col", {
        style: _normalizeStyle({ width: `${colW.ten}px` })
      }, null, 4),
      _createElementVNode("col", {
        style: _normalizeStyle({ width: `${colW.dacTinh}px` })
      }, null, 4),
      _createElementVNode("col", {
        style: _normalizeStyle({ width: `${colW.dvt}px` })
      }, null, 4),
      _createElementVNode("col", {
        style: _normalizeStyle({ width: `${colW.donGia}px` })
      }, null, 4),
      _createElementVNode("col", {
        style: _normalizeStyle({ width: `${colW.soLuong}px` })
      }, null, 4),
      _createElementVNode("col", {
        style: _normalizeStyle({ width: `${colW.thanhTien}px` })
      }, null, 4),
      _createElementVNode("col", {
        style: _normalizeStyle({ width: `${colW.soLuong}px` })
      }, null, 4),
      _createElementVNode("col", {
        style: _normalizeStyle({ width: `${colW.thanhTien}px` })
      }, null, 4),
      _createElementVNode("col", {
        style: _normalizeStyle({ width: `${colW.soLuong}px` })
      }, null, 4),
      _createElementVNode("col", {
        style: _normalizeStyle({ width: `${colW.thanhTien}px` })
      }, null, 4)
    ]),
    _createElementVNode("thead", _hoisted_1, [
      _createElementVNode("tr", _hoisted_2, [
        _createElementVNode("th", {
          rowspan: "2",
          class: "text-center chi-tiet-xuat-theo-dt-th-meta",
          width: colW.stt
        }, " TT ", 8, _hoisted_3),
        _createElementVNode("th", {
          colspan: "2",
          class: "text-center break-word",
          width: colW.dinhMucBbgt
        }, " Định mức, BBGT ", 8, _hoisted_4),
        _createElementVNode("th", {
          rowspan: "2",
          class: "text-center chi-tiet-xuat-theo-dt-th-meta break-word",
          width: colW.ma
        }, " Mã VT ", 8, _hoisted_5),
        _createElementVNode("th", {
          rowspan: "2",
          class: "text-center break-word chi-tiet-xuat-theo-dt-th-meta",
          width: colW.ten
        }, " Tên vật tư ", 8, _hoisted_6),
        _createElementVNode("th", {
          rowspan: "2",
          class: "text-center chi-tiet-xuat-theo-dt-th-meta break-word",
          width: colW.dacTinh
        }, " Đặc tính ", 8, _hoisted_7),
        _createElementVNode("th", {
          rowspan: "2",
          class: "text-center break-word chi-tiet-xuat-theo-dt-th-meta",
          width: colW.dvt
        }, " ĐVT ", 8, _hoisted_8),
        _createElementVNode("th", {
          rowspan: "2",
          class: "text-center break-word chi-tiet-xuat-theo-dt-th-meta",
          width: colW.donGia
        }, " Đơn giá ", 8, _hoisted_9),
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(columnArr, (header, index) => {
          return _createElementVNode("th", {
            key: index,
            colspan: "2",
            class: "text-center break-word",
            width: colW.quantityGroup
          }, _toDisplayString(header), 9, _hoisted_10)
        }), 64))
      ]),
      _createElementVNode("tr", _hoisted_11, [
        _createElementVNode("th", {
          class: "text-center break-word chi-tiet-xuat-theo-dt-th-so",
          width: colW.soBienBanGiaiThe
        }, " Số ", 8, _hoisted_12),
        _createElementVNode("th", {
          class: "text-center break-word",
          width: colW.ngay
        }, "Ngày", 8, _hoisted_13),
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (n) => {
          return (_openBlock(), _createElementBlock(_Fragment, { key: n }, [
            _createElementVNode("th", {
              class: "text-center break-word",
              width: colW.soLuong
            }, "Số lượng", 8, _hoisted_14),
            _createElementVNode("th", {
              class: "text-center break-word",
              width: colW.thanhTien
            }, " Thành tiền ", 8, _hoisted_15)
          ], 64))
        }), 64))
      ]),
      _hoisted_16
    ]),
    _createElementVNode("tbody", _hoisted_17, [
      (!__props.items.length)
        ? (_openBlock(), _createElementBlock("tr", _hoisted_18, _hoisted_20))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.items, (item, index) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: index,
                class: _normalizeClass({
            'bao-cao-table-data-row': __props.isPrintModal,
            'bao-cao-table-data-row--last':
              __props.isPrintModal && index === __props.items.length - 1,
          })
              }, [
                _createElementVNode("td", _hoisted_21, _toDisplayString(index + 1), 1),
                _createElementVNode("td", _hoisted_22, _toDisplayString(item.so_bien_ban_giai_the), 1),
                _createElementVNode("td", _hoisted_23, _toDisplayString(_unref(formatDisplayingDate)(new Date(item.ngay_lap))), 1),
                _createElementVNode("td", _hoisted_24, _toDisplayString(item.ma_vat_tu), 1),
                _createElementVNode("td", _hoisted_25, _toDisplayString(item.ten_vat_tu), 1),
                _hoisted_26,
                _createElementVNode("td", _hoisted_27, _toDisplayString(item.don_vi_tinh), 1),
                _createElementVNode("td", _hoisted_28, _toDisplayString(_unref(formatUnitPrice)(+item.don_gia_thuc_hien)), 1),
                _createElementVNode("td", _hoisted_29, _toDisplayString(_unref(formatQuantity)(+item.so_luong_dinh_muc)), 1),
                _createElementVNode("td", _hoisted_30, _toDisplayString(_unref(formatAmount)(+item.thanh_tien_dinh_muc_co_dinh)), 1),
                _createElementVNode("td", _hoisted_31, _toDisplayString(_unref(formatQuantity)(+item.so_luong_thuc_hien)), 1),
                _createElementVNode("td", _hoisted_32, _toDisplayString(_unref(formatAmount)(
                _unref(calcLineAmount)(
                  +item.don_gia_thuc_hien,
                  +item.so_luong_thuc_hien
                )
              )), 1),
                _createElementVNode("td", _hoisted_33, _toDisplayString(_unref(formatQuantity)(+item.so_luong_chenh_lech)), 1),
                _createElementVNode("td", _hoisted_34, _toDisplayString(_unref(formatAmount)(+item.thanh_tien_chenh_lech)), 1)
              ], 2))
            }), 128)),
            _createElementVNode("tr", _hoisted_35, [
              _hoisted_36,
              _hoisted_37,
              _hoisted_38,
              _createElementVNode("td", _hoisted_39, _toDisplayString(totalThanhTien.value.theo_dinh_muc), 1),
              _hoisted_40,
              _createElementVNode("td", _hoisted_41, _toDisplayString(totalThanhTien.value.thuc_hien), 1),
              _hoisted_42,
              _createElementVNode("td", _hoisted_43, _toDisplayString(totalThanhTien.value.chenh_lech), 1)
            ])
          ], 64))
    ])
  ], 2))
}
}

})